// extracted by mini-css-extract-plugin
export var footLine = "br11-f";
export var footTop = "br11-c";
export var footTopAddress = "br11-g";
export var footTopDesc = "br11-d";
export var footTopText = "br11-e";
export var footerM = "br11-b";
export var footerNavItem = "br11-i";
export var footerNavs = "br11-h";
export var minWidthLimit = "br11-a";